import { FilterArrayType } from 'common/components/Filters';
import { UserProfilesOrderBy } from 'common/types/globalTypes';
import { OrderDirection, SortOrder } from 'common/utils/commonTypes';

type OrderLookup = {
  [direction in OrderDirection]: UserProfilesOrderBy[];
};

const orderByMap = new Map<string, OrderLookup>([
  [
    'name',
    {
      [OrderDirection.ASC]: ['NAME_ASC'],
      [OrderDirection.DESC]: ['NAME_DESC'],
    },
  ],
  [
    'description',
    {
      [OrderDirection.ASC]: ['DESCRIPTION_ASC'],
      [OrderDirection.DESC]: ['DESCRIPTION_DESC'],
    },
  ],
  [
    'emailAccount',
    {
      [OrderDirection.ASC]: ['EMAIL_ACCOUNT_ASC'],
      [OrderDirection.DESC]: ['EMAIL_ACCOUNT_DESC'],
    },
  ],
  [
    'roleName',
    {
      [OrderDirection.ASC]: ['ROLE_BY_ROLE_ID__NAME_ASC'],
      [OrderDirection.DESC]: ['ROLE_BY_ROLE_ID__NAME_DESC'],
    },
  ],
  [
    'occupation',
    {
      [OrderDirection.ASC]: [
        'USER_OCCUPATION_TITLE_BY_USER_OCCUPATION_TITLE_ID__USER_OCCUPATION_TITLE_ASC',
      ],
      [OrderDirection.DESC]: [
        'USER_OCCUPATION_TITLE_BY_USER_OCCUPATION_TITLE_ID__USER_OCCUPATION_TITLE_DESC',
      ],
    },
  ],
  [
    'departmentName',
    {
      [OrderDirection.ASC]: [
        'DEPARTMENT_BY_DEPARTMENT_ID__NAME_ASC',
      ],
      [OrderDirection.DESC]: [
        'DEPARTMENT_BY_DEPARTMENT_ID__NAME_DESC',
      ],
    },
  ],
  [
    'accessPolicy',
    {
      [OrderDirection.ASC]: [
        'DATA_ACCESS_POLICY_BY_DATA_ACCESS_POLICY_ID__NAME_ASC',
      ],
      [OrderDirection.DESC]: [
        'DATA_ACCESS_POLICY_BY_DATA_ACCESS_POLICY_ID__NAME_DESC',
      ],
    },
  ],
  [
    'invited',
    {
      [OrderDirection.ASC]: ['INVITED_ASC'],
      [OrderDirection.DESC]: ['INVITED_DESC'],
    },
  ],
  [
    '_lastUsedDate',
    {
      [OrderDirection.ASC]: ['_LAST_USED_DATE_ASC'],
      [OrderDirection.DESC]: ['_LAST_USED_DATE_DESC'],
    },
  ],
  [
    'rank',
    {
      [OrderDirection.ASC]: [
        'USER_RANK_TYPE_BY_USER_RANK_TYPE_ID__USER_RANK_ASC',
      ],
      [OrderDirection.DESC]: [
        'USER_RANK_TYPE_BY_USER_RANK_TYPE_ID__USER_RANK_DESC',
      ],
    },
  ],
  [
    'securityLevel',
    {
      [OrderDirection.ASC]: [
        'SECURE_ROW_LEVEL_BY_SECURE_ROW_LEVEL_ID__SECURITY_LEVEL_ASC',
      ],
      [OrderDirection.DESC]: [
        'SECURE_ROW_LEVEL_BY_SECURE_ROW_LEVEL_ID__SECURITY_LEVEL_DESC',
      ],
    },
  ],
  [
    'inviteStatus',
    {
      [OrderDirection.ASC]: [
        'USER_INVITE_STATUS_TYPE_BY_INVITATION_STATUS_TYPE_ID__STATUS_TYPE_ASC',
      ],
      [OrderDirection.DESC]: [
        'USER_INVITE_STATUS_TYPE_BY_INVITATION_STATUS_TYPE_ID__STATUS_TYPE_DESC',
      ],
    },
  ],
  [
    'approvalStatus',
    {
      [OrderDirection.ASC]: [
        'USER_STATUS_TYPE_BY_STATUS_TYPE_ID__APPROVAL_STATE_ASC',
      ],
      [OrderDirection.DESC]: [
        'USER_STATUS_TYPE_BY_STATUS_TYPE_ID__APPROVAL_STATE_DESC',
      ],
    },
  ],
]);

export const toOrderByVariable = (sort?: SortOrder) => {
  const orderByArray: UserProfilesOrderBy []= ['NAME_ASC'];
  if (!sort) return orderByArray;

  const orderBy = orderByMap.get(sort.column)?.[sort.direction];
  return Array.from(new Set([...(orderBy ? orderBy : []), ...orderByArray]));
};

export const toPaymentFilterVariable = (filterList: FilterArrayType[]) =>
  filterList.map((filter) => {
    switch (filter.filterKey) {
      case 'roleId':
      case 'userOccupationTitleId':
      case 'departmentId':
      case 'dataAccessPolicyId':
      case '_invitationStatusTypeId':
      case '_statusTypeId':
        return {
          [filter.filterKey]: {
            equalTo: filter.value,
          },
        };

      default:
        return undefined;
    }
  });
